<!-- 申请列表 -->
<template>
  <div class="zlr-appointment-list">
    <div>
      <div class="zlr-appointment-list-title"
           :title="name">{{name}}</div>
      <div class="zlr-appointment-list-con"
           v-if="con">{{con}}</div>
      <div class="zlr-appointment-list-prompt"
           :class="[color]"
           :style="{width: !con? '900px':''}">
        <span @click="promptHandle">{{prompt}}</span>
        <div class="zlr-appointment-list-circle"></div>
      </div>
    </div>
  </div>
</template>

<script>
// less
import './index.less'
export default {
  name: 'zlr-appointment-list',
  components: {},
  props: ['name', 'con', 'prompt', 'color'],
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {
    promptHandle () {
      this.$emit('click')
    }
  }
}
</script>
<style lang='less' scoped>
</style>
